/* eslint-disable */
import React from 'react';
import { Expansion } from './Expansion';
import { IExpansion, IParentExpansion } from './types';

export abstract class ParentExpansion<T> extends Expansion<T> implements IParentExpansion {
  private readonly _children: IExpansion[] = [];

  public get boundChildren(): any {
    if (this.props.children) {
      const children = React.Children.toArray(this.props.children);
      return children.map((child, i) => this.bind(child, `c-${i}`)).filter(x => x);
    }
    return this.props.children;
  }

  public bind(child: React.ReactNode | undefined, key: string): React.ReactNode | undefined {
    if (child && typeof child !== 'string') {
      const clone = React.cloneElement(child as any, { parent: this, key });
      this._children.push(clone as any);
      return clone;
    }
    return child;
  }

  expandAll = () => {
    this._children.forEach(x => x.expand());
  }

  collapseAll = () => {
    this._children.forEach(x => x.collapse());
  }

  toggleExpandAll = () => {
    if (this.state.expanded) {
      this.collapseAll();
    } else {
      this.expandAll();
    }
  }
}

export default ParentExpansion;
